
import createIconComponent from '../utils/createIconComponent';
import { SVG_CHECKMARK_CIRCLE_OUTLINED } from '../../../dist';
import React from 'react';
const CheckmarkCircleOutlinedIcon = createIconComponent({ content: SVG_CHECKMARK_CIRCLE_OUTLINED, height: 24, width: 24 });
CheckmarkCircleOutlinedIcon.displayName = 'CheckmarkCircleOutlinedIcon';
export default CheckmarkCircleOutlinedIcon;
